import { getSupabase } from './supabase-client.js';
import { OfflineError, isOnline } from './store.js';

function assertCanEdit() {
  if (!isOnline()) throw new OfflineError();
}

/**
 * @param {string} instanceId
 */
export async function listCustomTicketItems(instanceId) {
  const supabase = getSupabase();
  const { data, error } = await supabase
    .from('instance_ticket_items')
    .select('id, label, note, sort_order, created_at')
    .eq('instance_id', instanceId)
    .order('sort_order')
    .order('created_at');
  if (error) throw error;
  return data ?? [];
}

/**
 * @param {string} instanceId
 * @param {{ label: string, note?: string }} payload
 */
export async function createCustomTicketItem(instanceId, { label, note = null }) {
  assertCanEdit();
  const trimmed = String(label ?? '').trim();
  if (!trimmed) throw new Error('Inserisci un nome per la voce.');

  const supabase = getSupabase();
  const { data: existing } = await supabase
    .from('instance_ticket_items')
    .select('sort_order')
    .eq('instance_id', instanceId)
    .order('sort_order', { ascending: false })
    .limit(1)
    .maybeSingle();

  const sortOrder = (existing?.sort_order ?? -1) + 1;

  const { data, error } = await supabase
    .from('instance_ticket_items')
    .insert({
      instance_id: instanceId,
      label: trimmed,
      note: note?.trim() || null,
      sort_order: sortOrder,
    })
    .select('id, label, note, sort_order, created_at')
    .single();
  if (error) throw error;
  return data;
}

/**
 * @param {string} instanceId
 * @param {string} itemId
 */
export async function deleteCustomTicketItem(instanceId, itemId) {
  assertCanEdit();
  const supabase = getSupabase();
  const { error } = await supabase
    .from('instance_ticket_items')
    .delete()
    .eq('id', itemId)
    .eq('instance_id', instanceId);
  if (error) throw error;
}

/**
 * Group files by link target.
 * @param {Array<{ catalog_index?: number | null, ticket_item_id?: string | null }>} files
 */
export function groupFilesByLink(files) {
  const byCatalog = new Map();
  const byCustom = new Map();
  const unlinked = [];

  for (const file of files) {
    if (file.catalog_index != null && Number.isInteger(file.catalog_index)) {
      const list = byCatalog.get(file.catalog_index) ?? [];
      list.push(file);
      byCatalog.set(file.catalog_index, list);
    } else if (file.ticket_item_id) {
      const list = byCustom.get(file.ticket_item_id) ?? [];
      list.push(file);
      byCustom.set(file.ticket_item_id, list);
    } else {
      unlinked.push(file);
    }
  }

  return { byCatalog, byCustom, unlinked };
}
